module.exports = __webpack_public_path__ + "static/img/pic12.1755ed97.png";